import React from 'react';
import { motion } from 'framer-motion';
export function Newsletter() {
  return <section className="bg-accent-dark py-24 lg:py-32 border-thick-b" data-id="element-163">
      <div className="max-w-[96rem] mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-164">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-165">
          <h2 className="font-serif text-6xl sm:text-7xl lg:text-8xl xl:text-9xl font-black tracking-tighter leading-[0.85] mb-8 text-cream uppercase" data-id="element-166">
            The best of Skybox
            <br data-id="element-167" />
            in your inbox.
          </h2>
          <p className="font-sans text-2xl sm:text-3xl font-bold text-cream/90 mb-12 max-w-3xl mx-auto leading-snug" data-id="element-168">
            Join 50,000+ league executives, agents, operators, and investors who
            follow the business of sports each week. No spam, just signal.
          </p>

          <form className="flex flex-col sm:flex-row max-w-2xl mx-auto gap-4" onSubmit={e => e.preventDefault()} data-id="element-169">
            <input type="email" placeholder="ENTER YOUR EMAIL" className="flex-grow bg-cream border-4 border-ink px-6 py-5 font-mono text-lg font-bold text-ink placeholder:text-ink/40 focus:outline-none focus:border-cream focus:ring-4 focus:ring-ink transition-all uppercase tracking-widest" required data-id="element-170" />
            <button type="submit" className="bg-ink hover:bg-cream hover:text-ink text-cream px-10 py-5 font-sans text-xl font-black uppercase tracking-widest transition-colors whitespace-nowrap border-4 border-ink" data-id="element-171">
              Subscribe
            </button>
          </form>
          <p className="font-mono text-sm font-bold uppercase tracking-widest text-cream/60 mt-8" data-id="element-172">
            By subscribing, you agree to our Terms of Service and Privacy
            Policy.
          </p>
        </motion.div>
      </div>
    </section>;
}